import type { ReactNode } from 'react';
import { Header } from './_shared';

export type DoubleColumnSlideProps = {
  eyebrow: ReactNode;
  title?: ReactNode;
  left: ReactNode;
  right: ReactNode;
  /** Optional full-height image panel on the right (pushes the two columns left). */
  image?: { src: string; alt: string };
  /** Optional extra class on the slide-body root, for deck-local scoping. */
  className?: string;
};

export function DoubleColumnSlide({ eyebrow, title, left, right, image, className }: DoubleColumnSlideProps) {
  return (
    <div className={`slide-body${className ? ` ${className}` : ''}`}>
      <Header eyebrow={eyebrow} title={title} />
      <div className={`sn-work${image ? ' sn-work--with-image' : ''}`}>
        <div className="sn-body-2col">
          <div>{left}</div>
          <div>{right}</div>
        </div>
        {image && (
          <div className="sn-image-panel">
            <img src={image.src} alt={image.alt} />
          </div>
        )}
      </div>
    </div>
  );
}
